export default __webpack_public_path__ + "static/media/Shemite Exile Cache.84edd856.jpg";